import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="text-white py-12" style={{ backgroundColor: '#d9a79c' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-12 gap-10"
        >
          {/* Brand */}
          <div className="md:col-span-4 md:-ml-16">
            <img 
              src="/images/Aleracurrent_charcoaltrans.png" 
              alt="Alera" 
              className="h-32 md:h-40 w-auto mb-2 md:-mb-6 md:-mt-12"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
            <p className="text-sm md:text-base text-white/90 mb-6 leading-relaxed max-w-sm">
              Empowering women to transform their health struggles into strength through allergy-friendly recipes,
              holistic wellness, and supportive community.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/alera.living"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/80 transition-colors duration-200"
                onMouseEnter={(e) => e.currentTarget.style.color = '#3a3a3a'}
                onMouseLeave={(e) => e.currentTarget.style.color = ''}
                aria-label="Follow us on Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61584902072892"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/80 transition-colors duration-200"
                onMouseEnter={(e) => e.currentTarget.style.color = '#3a3a3a'}
                onMouseLeave={(e) => e.currentTarget.style.color = ''}
                aria-label="Follow us on Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href="https://www.tiktok.com/@alera.co.nz"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/80 transition-colors duration-200"
                onMouseEnter={(e) => e.currentTarget.style.color = '#3a3a3a'}
                onMouseLeave={(e) => e.currentTarget.style.color = ''}
                aria-label="Follow us on TikTok"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05 0-12.07z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Company */}
          <div className="md:col-span-3">
            <h3 className="text-sm font-semibold text-white tracking-wider uppercase mb-4">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-white/80 transition-colors" onMouseEnter={(e) => e.currentTarget.style.color = '#3a3a3a'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>About</Link></li>
              <li><Link to="/services" className="text-white/80 transition-colors" onMouseEnter={(e) => e.currentTarget.style.color = '#3a3a3a'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>Services</Link></li>
              <li><Link to="/contact" className="text-white/80 transition-colors" onMouseEnter={(e) => e.currentTarget.style.color = '#3a3a3a'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>Contact</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="md:col-span-3">
            <h3 className="text-sm font-semibold text-white tracking-wider uppercase mb-4">Legal</h3>
            <ul className="space-y-3">
              <li><Link to="/privacy-policy" className="text-white/80 transition-colors" onMouseEnter={(e) => e.currentTarget.style.color = '#3a3a3a'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>Privacy Policy</Link></li>
              <li><Link to="/terms-conditions" className="text-white/80 transition-colors" onMouseEnter={(e) => e.currentTarget.style.color = '#3a3a3a'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>Terms & Conditions</Link></li>
              <li><Link to="/refund-cancellation" className="text-white/80 transition-colors" onMouseEnter={(e) => e.currentTarget.style.color = '#3a3a3a'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>Refund & Cancellation</Link></li>
              <li><Link to="/health-disclaimer" className="text-white/80 transition-colors" onMouseEnter={(e) => e.currentTarget.style.color = '#3a3a3a'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>Health & Fitness Disclaimer</Link></li>
              <li><Link to="/terms-conditions#cookies" className="text-white/80 transition-colors" onMouseEnter={(e) => e.currentTarget.style.color = '#3a3a3a'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>Cookie Policy</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-white tracking-wider uppercase mb-4">Connect</h4>
            <ul className="space-y-3 text-white/80">
              <li>
                <a href="mailto:hello@alera.co.nz" className="transition-colors" onMouseEnter={(e) => e.currentTarget.style.color = '#3a3a3a'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>
                  hello@alera.co.nz
                </a>
              </li>
              <li>
                <Link to="/login" className="transition-colors" onMouseEnter={(e) => e.currentTarget.style.color = '#3a3a3a'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>
                  Support Community
                </Link>
              </li>
            </ul>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="border-t border-white/30 mt-10 pt-6 flex flex-col md:flex-row items-center md:justify-between text-center md:text-left gap-2 md:gap-4 text-sm text-white/80"
        >
          <p>&copy; 2025–2026 Alera. All rights reserved.</p>
          <div className="text-xs text-white/70">Evidence-based wellness for women.</div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
